import { useMemo, useState } from 'react'
import type { FormDefinition, FormField, FormLogic } from '../types/forms'
import type { ClientFormDefinition } from '../types/clientEmail'
import { LogicEngine } from '../utils/formLogicEngine'

export const useFormState = (
  definition: FormDefinition | ClientFormDefinition | { fields: FormField[]; logic?: FormLogic | null },
  initialValues?: Record<string, unknown>,
) => {
  const [values, setValues] = useState<Record<string, unknown>>(() => initialValues ?? {})
  const [errors, setErrors] = useState<Record<string, string>>({})
  const [step, setStep] = useState(0)
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const visibleFields = useMemo(() => LogicEngine.visibleFields(definition, values), [definition, values])
  const steps = useMemo(() => Array.from(new Set(visibleFields.map(LogicEngine.stepFor))).sort((a, b) => a - b), [visibleFields])
  const activeStep = steps[Math.min(step, Math.max(0, steps.length - 1))] ?? 0
  const stepFields = visibleFields.filter((field) => LogicEngine.stepFor(field) === activeStep)
  const setValue = (fieldId: string, value: unknown) => {
    setValues((current) => ({ ...current, [fieldId]: value }))
    setErrors((current) => { const next = { ...current }; delete next[fieldId]; return next })
  }
  return {
    values, setValue, errors, setErrors, step, setStep, steps, activeStep, stepFields, visibleFields,
    submitting, setSubmitting, submitted, setSubmitted,
    reset: () => { setValues({}); setErrors({}); setStep(0); setSubmitted(false) },
  }
}
